import { render, staticRenderFns } from "./actStage.vue?vue&type=template&id=7d35ea3b&scoped=true&"
import script from "./actStage.vue?vue&type=script&lang=js&"
export * from "./actStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35ea3b",
  null
  
)

export default component.exports